import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';

import { selectConversationById, sortConversationsBySentTime } from 'models/conversations';
import { RONGCLOUD_CHATROOM_PREFIX } from 'appenv';
import ChatListPlaceholder from 'assets/chatListPlaceholder.svg';

import CollapsibleChatGroupView from './CollapsibleChatGroupView';
import ChatConversationListItem from './ChatConversationListItem';

const ChatListPlaceholderContainer = styled.div`
  text-align: center;
  padding-top: 120px;
`;

const StyledImg = styled.img`
  max-height: 100px;
  max-width: 100px;
`;

const StyledBoldTitle = styled.div`
  font-weight: 900;
  font-size: 18px;
  color: #484848;
  margin: 24px 0 16px 0;
`;

const StyledText = styled.div`
  margin: 0 34px;
  color: #484848;
  font-size: 14px;
  font-weight: normal;
`;

const ChatConversationList = ({
  setChatTarget,
}) => {
  const { t } = useTranslation();
  const announcement = useSelector((state) => (selectConversationById(state, `${RONGCLOUD_CHATROOM_PREFIX}_announcement`))) || {};
  const conversations = useSelector(sortConversationsBySentTime());
  const privateChat = conversations.filter((chat) => (chat.conversationType === 'private'));
  const groupChat = conversations.filter((chat) => (chat.conversationType === 'group'));

  return (
    <>
      {
        (isEmpty(announcement) && !groupChat.length && !privateChat.length) ? (
          <ChatListPlaceholderContainer>
            <StyledImg src={ChatListPlaceholder} alt="Chat list is empty" />
            <StyledBoldTitle>No messages yet</StyledBoldTitle>
            <StyledText>Visit any booth and start chatting with people in booth chatroom</StyledText>
          </ChatListPlaceholderContainer>
        ) : (
          <>
            <ChatConversationListItem
              displayName={t('announcement', announcement.name)}
              conversation={announcement}
              setChatTarget={setChatTarget}
            />
            <CollapsibleChatGroupView
              chatList={groupChat}
              type="group"
              setChatTarget={setChatTarget}
            />
            <CollapsibleChatGroupView
              chatList={privateChat}
              type="private"
              setChatTarget={setChatTarget}
            />
          </>
        )
      }
    </>
  );
};

ChatConversationList.propTypes = {
  setChatTarget: PropTypes.func.isRequired,
};

export default ChatConversationList;
